import userService from "../../../services/user.service";

async function getPracticeLocationTypes() {
  try {
    const response = await userService.getPracticeLocationTypes();

    if (response.data && response.data.status) {
      console.log(response.data.result);
      return JSON.stringify(response.data.result);
    } else {
      return (
        JSON.stringify(response.data.message) || "Failed to fetch location types."
      );
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    console.error("Error fetching practice location types:", errorMessage);
    return JSON.stringify(errorMessage);
  }
}

async function getPracticeLocationsByCityId({ cityId }) {
  try {
    const response = await userService.getPracticeLocations({
      filter: {
        textSearch: "",
        city: cityId,
      },
      pageNumber: -1,
      pageSize: 0,
    });
    if (response.data && response.data.status) {
      console.log(response.data.result);
      return JSON.stringify(response.data.result);
    } else {
      return (
        JSON.stringify(response.data.message) ||
        "Failed to get Practice locations."
      );
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    return JSON.stringify(errorMessage);
  }
}
async function addPracticeLocation({ name, type, address, city }) {
  try {
    const payload = {
      id: 0, 
      name,
      type,     
      address,
      city,     
    };

    const response = await userService.addPracticeLocation(payload);
    if (response.data && response.data.status) {
      console.log("Practice location added:", response.data.result);
      return JSON.stringify(response.data.result);
    } else {
      return (
        JSON.stringify(response.data.message) ||
        "Failed to add practice location."
      );
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    console.error("Error adding practice location:", errorMessage);
    return JSON.stringify(errorMessage);
  }
}
async function updatePracticeLocation({ id, name, type, address, city }) {
  try {
    const payload = {
      id,
      name,
      type,     
      address,
      city,    
    };

    const response = await userService.updatePracticeLocation(payload);
    if (response.data && response.data.status) {
      console.log("Practice location updated:", response.data.result);
      return JSON.stringify(response.data.result);
    } else {
      return (
        JSON.stringify(response.data.message) ||
        "Failed to update practice location."
      );
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    console.error("Error updating practice location:", errorMessage);
    return JSON.stringify(errorMessage);
  }
}


export default {
  getPracticeLocationsByCityId,
  getPracticeLocationTypes,
  addPracticeLocation,
  updatePracticeLocation,
  practiceLocationTools: [
    {
      type: "function",
      function: {
        name: "getPracticeLocationsByCityId",
        description:
          "Get practice locations of specific city from the database. Practice locations are actually hospitals like locations.",
        parameters: {
          type: "object",
          properties: {
            cityId: {
              type: "string",
              description:
                "The id of the city in database of which we want to get practice locations.",
            },
          },
          required: ["cityId"],
        },
      },
    },
    {
      type: "function",
      function: {
        name: "getPracticeLocationTypes",
        description:
        "Fetch all practice location types from the database. A practice location type refers to the category of a location, such as 'Hospital', 'Clinic', or 'Urgent Care'.",
        parameters: {
          type: "object",
          properties: {
              pageNumber: {
                  type: "number",
                  description:
                    "The page number for paginated results. Dont ask this just use default values. by default it is -1 for fetching all Location Types",
                },
                pageSize: {
                  type: "number",
                  description:
                    "The number of items per page. by default it is 0 for fetching all Location Types",
                },
                searchQuery: {
                  type: "string",
                  description:
                    "Search query to filter cities. by default it is empty string for fetching all Location Types",
                },
          }
        },
      },
    },
    {
      type: "function",
      function: {
        name: "addPracticeLocation",
        description: `Add a new practice location to the system. 
          Before calling this function, you MUST call getPracticeLocationTypes to retrieve all available location types, 
          and getCities to retrieve all available cities. 
          Display both as dropdowns for selection. Also, present fields for location name and address.`,
        parameters: {
          type: "object",
          properties: {
            name: {
              type: "string",
              description: "The name of the practice location.",
            },
            type: {
              type: "integer",
              description: "The ID of the location type. Use getPracticeLocationTypes to retrieve available types.",
            },
            address: {
              type: "string",
              description: "The full street address of the practice location.",
            },
            city: {
              type: "integer",
              description: "The ID of the city where the location is based. Use getCities to retrieve available cities.",
            },
          },
          required: ["name", "type", "address", "city"],
        },
      },
    },
    {
      type: "function",
      function: {
        name: "updatePracticeLocation",
        description: `Update an existing practice location in the system. 
          Before calling this function, you MUST call getPracticeLocationTypes to retrieve all available location types, 
          and getCities to retrieve all available cities. 
          Display both as dropdowns for selection. Also, present fields for location name and address. 
          The ID of the practice location to be updated is required.`,
        parameters: {
          type: "object",
          properties: {
            id: {
              type: "integer",
              description: "The unique ID of the practice location to update.",
            },
            name: {
              type: "string",
              description: "The updated name of the practice location.",
            },
            type: {
              type: "integer",
              description: "The updated location type ID. Use getPracticeLocationTypes to retrieve available types.",
            },
            address: {
              type: "string",
              description: "The updated street address of the practice location.",
            },
            city: {
              type: "integer",
              description: "The updated city ID. Use getCities to retrieve available cities.",
            },
          },
          required: ["id", "name", "type", "address", "city"],
        },
      },
    }    
    
  ]
};
